var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-count text-nowrap"},[_c('span',{class:{ 'gl-text-red-700': _vm.issuesExceedMax },attrs:{"data-testid":"board-items-count"}},[_vm._v("\n    "+_vm._s(_vm.itemsSize)+"\n  ")]),_vm._v(" "),(_vm.isMaxLimitSet)?_c('span',{staticClass:"max-issue-size"},[_vm._v("\n    "+_vm._s(`/ ${_vm.maxIssueCount}`)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }